import { render, staticRenderFns } from "./shuttle.vue?vue&type=template&id=f2d9120a&scoped=true"
import script from "./shuttle.vue?vue&type=script&lang=js"
export * from "./shuttle.vue?vue&type=script&lang=js"
import style0 from "./shuttle.vue?vue&type=style&index=0&id=f2d9120a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d9120a",
  null
  
)

export default component.exports